import { createRoot, type Root } from "react-dom/client";
import Missions from "../pages/Missions/Missions";
import "../index.css";
import "../pages/Missions/Missions.custom.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) return;

  root = createRoot(element);
  root.render(<Missions />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADMissions = { mount, unmount };

function boot() {
  const element = document.getElementById("missions-root");
  if (element) mount(element);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
